import firebase from "firebase";
import "firebase/storage";

// OLD
// var firebaseConfig = {
//   apiKey: "AIzaSyAKxX1t8QWY9RpwIJAUg_T1K9xHd-gz3ss",
//   authDomain: "react-videos-b7383.firebaseapp.com",
//   projectId: "react-videos-b7383",
//   storageBucket: "react-videos-b7383.appspot.com",
//   messagingSenderId: "671588442640",
//   appId: "1:671588442640:web:0e2d620d64e33f1f342095",
//   measurementId: "G-DDRG105W1R",
// };
// NEW
const firebaseConfig = {
  apiKey: "AIzaSyDeMNaNLRz3xd4B0mtZcPv2YkMRpqrTYJ4",
  authDomain: "money-app-12dea.firebaseapp.com",
  projectId: "money-app-12dea",
  storageBucket: "money-app-12dea.appspot.com",
  messagingSenderId: "283880374861",
  appId: "1:283880374861:web:19de4295f2e73129761204",
  measurementId: "G-EFPPJT89G5",
};

const fire = firebase.initializeApp(firebaseConfig);

export default fire;
